import { useEffect } from 'react';

/**
 * Lightweight per-page <title> + meta description updater.
 * Restores the HTML default on unmount so client-side nav stays clean.
 */
const useDocumentTitle = (title, description) => {
  useEffect(() => {
    const prevTitle = document.title;
    const descEl = document.querySelector('meta[name="description"]');
    const prevDesc = descEl ? descEl.getAttribute('content') : '';

    if (title) document.title = title;
    if (description && descEl) descEl.setAttribute('content', description);

    return () => {
      document.title = prevTitle;
      if (descEl && prevDesc) descEl.setAttribute('content', prevDesc);
    };
  }, [title, description]);
};

export default useDocumentTitle;
